import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/input-round.scss'

function Element({ value, className, placeholder = '입력하세요.', disabled = false }) {
  return (
    <div className="box">
      <input
        type="text"
        className={'input-text ' + className}
        defaultValue={value}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  )
}

export default Element
